<template>
  <section>
    <leo-dialog
      :show="isShow"
      containerClass="custom-zindex"
      persistence
      maxWidth="704px"
    >
      <div class="leo-m-auto tablet:leo-w-2/3 leo-py-3xl">
        <div
          class="leo-text-lg leo-text-secondary leo-font-semibold leo-text-center"
        >
          {{ refreshProps.heading }}
        </div>
        <div v-if="refreshProps.imageType">
          <svg
            width="100%"
            height="194"
            viewBox="0 0 299 194"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              transform="translate(1.000000, 0.000000)"
              fill="none"
              fill-rule="evenodd"
            >
              <g transform="translate(100.000000, 0.000000)">
                <path
                  d="M52.8 22.5c-.1-2.4-.3-.7-.8-3-1.1-4.7-3.4-7.5-8.4-8.5-2.7-.5-5.6-.4-8.3 0-5.1.7-10.2 2.1-14.9
                4.2-3.5 1.5-10.7 4.1-11.4 8.2-.3 3 .1 6.1-.5 9-.3 1.4-.3 2.8-.2 4.3.1.6.2 4.1.7 4.4-2.2-1.3-5.3-.1-5.6
                2.4-.1 1.2-.2 2.5.2 3.7.2.6.6 1.2 1 1.7 1.7 2.2 4.2 4.1 7.2 3.1.6-.2 1.4-.5 1.9 0 .2.2.3.5.4.7 1.4 3.6
                2.7 7.3 3.7 11.1.5 1.8.9 3.6.9 5.4 0 1.2-.3 2.3-.4 3.4-.3 3 0 7 1.2 9.9.9 2.3 4.5 3.2 6.7 3.7 5.5 1.4
                11.1.8 16.1-1.7 2.4-1.2 4.2-3.2 5.2-5.7.6-3.3-1.3-6.6-3.1-9.3-1.9-3-3.3-7.8.4-9.8 3.6-1.9 5.7-6.2 6.7-10
                1.2-4.2 1.3-8.8 1.5-13.1.3-4.6 0-9.5-.2-14.1z"
                  stroke="#000"
                  stroke-width="1.5"
                  fill="#FFF"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M46.3 75.1c-.8-1.6-4.5-10.9-4.3-12.7m5.7-32c-.7-1.2-1.9-1.6-3.1-1.1-.4.3-.5.6-.9.9"
                  stroke="#000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <ellipse
                  fill="#000"
                  fill-rule="nonzero"
                  transform="translate(46.007618, 35.602655) rotate(-2.862668)
                translate(-46.007618, -35.602655)"
                  cx="46.008"
                  cy="35.603"
                  rx="1.5"
                  ry="2.3"
                />
                <path
                  d="M29.6 34c.8 0 1.4 1 1.5 2.4.1 1.4-.5 2.5-1.3 2.6-.8 0-1.4-1-1.5-2.4-.1-1.4.5-2.5 1.3-2.6z"
                  fill="#000"
                  fill-rule="nonzero"
                />
                <path
                  d="M38.4 41.5c2.8-2.4 0-2.7-1.1-4.9m-5.7-5.4c-.1-.7-1.1-1.3-2.2-1.3-.9.1-1.7.5-2 1-.2.3-.4.5-.5.8"
                  stroke="#000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <g stroke="#000" stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="M10.1 48c.1-1.3-.3-2.7-1.1-3.3-.8-.6-1.8-.5-2.6.2m2.3.1c-.6.6-.9 1.4-1.1 2.3"
                    stroke-width="1.2"
                  />
                  <path
                    d="M53.5 30.1c.8-.1 1.5.3 2.1.7 1.2 1 2 6.1 0 7.1-.4.2-2.2.8-2.6.8"
                    stroke-width="1.5"
                  />
                </g>
                <path
                  d="M49.8 23c-1.1-1.8-2.3-3.3-3.7-4.3-3.5-2.6-9.4.8-12.8 2.1-4.8 1.8-8.8 5.2-13.9 6.6-3.7 1-4.6
                4.9-4.5 8.1.1 3.7.4 7.2.1 11-.1.6-.2 1.3-.9
                1.4-.7.1-1.1-.6-1.4-1.1-2-3.4-5.5-5.1-7.6-8.3-1.7-2.5-2.9-5.4-3.7-8.3-.8-3.2-.5-5.9.9-8.9 1.8-3.9
                5.6-5.9 9.3-7.7 4.2-2.1 8.8-4.2 12.6-7 2.3-1.7 4.6-3.5 7.3-4.7C34.1.7 37.1 0 39.9.6c2.7.5 4.6 2.1 6 4.3
                1.2 1.8 2.8 3.1 4.5 4.3 1.6 1.2 3.5 2.1 4.5 3.9 1.5 2.8 1.3 6.8.7 9.9-.3 1.6-1.1 3.2-1.6 4.8-.3.9-1.4
                3.5-.9 4.5-1.1-2.1-1.6-6.7-3.3-9.3z"
                  fill="#000"
                  fill-rule="nonzero"
                />
                <path
                  d="M10.6 26.6c-.7-.4-1.4-.9-2.2-1.3-1.1-.6-2.6-1.2-3.4-2-1.1-1.1.1-.8 1.6-.1.8.4 1.6.8 2.3 1.3 1.5.9
                2.9 1.8 4.4 2.7.5.3 1.1.7 1.4 1-.9 0-2-.5-3-1.1-.5-.1-.8-.3-1.1-.5zm25.9-14.7c-.3.1-.6
                0-.7-.2-.2-.3-.1-.6.2-.8.6-.3 1-.8 1.2-1.5.1-.5 0-1.4.5-1.7.2-.1.4 0 .5.1.5.5.2 1.8-.1 2.4-.3.8-.9
                1.3-1.6 1.7zm4 1.6c-.1.1-.3.1-.5 0-.3-.1-.4-.5-.3-.7.4-.9.7-1.8.9-2.8.1-.3.1-.7.2-1 0-.3 0-.7.2-.9
                0-.1.1-.1.2-.1s.2.1.3.2c.2.3.3.5.4.8.2.6-.1 1.4-.2 2.1-.2.8-.4 1.5-.8 2.2-.1.1-.2.2-.4.2z"
                  fill="#FFF"
                  fill-rule="nonzero"
                />
                <path
                  d="M31.5 44.9c.1.6.4 1.2.6 1.7.8 1.5 1.7 3.2 3 4 .9.5 1.9.4 2.8-.1.4-.3.8-.6
                1.1-.9.3-.3.6-1.2.9-1.3-1.5.5-2.9.3-4.3-.4-.8-.3-1.5-.8-2.2-1.2-.3-.3-.7-.5-1-.8-.2-.1-.8-.5-.9-.8v-.2z"
                  stroke="#000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <ellipse
                fill="#B1B1B2"
                fill-rule="nonzero"
                cx="96.4"
                cy="190"
                rx="11.1"
                ry="3"
              />
              <path
                stroke="#000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M63
            159H.2m296.2 0h-74.9"
              />
              <path
                d="M118.2 100.2c.1-.5.1-1.1.2-1.6.2-2.8-1.1-6.5.3-9.1 3.6-6.8 18.8-9.1 27.1-10.2 2.6-.3 5.2-.8 7.6-1.5
            2.2-.5 3.7-.6 5.6-1.7.3-.2.6-.4.9-.7
            8.4-9.1-10.1-13-17.9-14.4-4.2-.7-8.5-1-12.7-.9-5.9.2-11.6-.3-17.5.7-3.2.5-6.8 1.5-8.3 4.4-.9 1.6-.9 3.6-.9
            5.5 0 3.9-.3 7.8 0 11.6.4 3.9.2 7.9-.5 11.8-.5 2.9-1.6 5.6-2.3 8.4-1 3.8-1.4 7.9-1.9 11.8 1.8-.2 3.5.4 5.2
            1.1.6.2 1.1.4 1.7.6 1.3.5 1.8 1.6 3.2 1.7 1.4.1 3-1.2 3.7-2.3 2.8-4.5 5.7-10.1 6.5-15.2z"
                stroke="#231F20"
                stroke-width="1.5"
                fill="#ED1D24"
                fill-rule="nonzero"
              />
              <path
                d="M80.2 53.2c-2.9 2.3-5 5.4-6.1 8.9-.8 2.6-1 5.2-.6 7.9m12.2-11.7c-1.8 1.5-3.2 3.4-3.9 5.7-.5 1.6-.6
            3.3-.4 5m129.3-7.1c-.5-3.7-2.1-7.1-4.5-9.8-1.8-2-4-3.5-6.5-4.5m3.8
            16.4c-.3-2.3-1.3-4.5-2.9-6.3-1.2-1.2-2.6-2.2-4.1-2.9"
                stroke="#000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                stroke="#000"
                stroke-width="1.5"
                fill="#FFF"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M129.8 174.9l-9 13.4-9.6-3.8 1.7-25.5"
              />
              <path
                stroke="#000"
                stroke-width="1.5"
                fill="#034694"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M143.4 180.5l-2.6 2.7-20 5.1 9-13.4"
              />
              <path
                d="M151.3 78.7c-27-1.8-48.7 19.8-48.6 48.3.1 28.5 22.1 53 49.1 54.8 27 1.8 48.7-19.8
            48.6-48.2-.2-28.5-22.2-53-49.1-54.9z"
                stroke="#000"
                stroke-width="1.5"
                fill="#FFF"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M183.8 94l-29.5 34.8H200c-1.1-13.1-6.9-25.4-16.2-34.8z"
                fill="#E2E3E4"
                fill-rule="nonzero"
              />
              <path
                d="M154.5 79.3l-.8.5-.3 50.1 30.4-34.7c-7.9-8.3-18.1-13.9-29.3-15.9z"
                fill="#D8D8D9"
                fill-rule="nonzero"
              />
              <path
                d="M174 68c-7.6-.5-15.2.9-22.1 4.1l-22.7 10.7c6.9-3.2 14.5-4.6 22.1-4.1 27 1.8 48.9 26.4 49 54.8.1
            20-10.7 36.7-26.5 44.1l22.7-10.7c15.8-7.5 26.6-24.1 26.5-44.1-.1-28.4-22.1-53-49-54.8z"
                stroke="#000"
                stroke-width="1.5"
                fill="#034694"
                fill-rule="nonzero"
              />
              <path
                d="M192.7 105.7c3-3 4.6-5.1 4.7-5.5 2.1-5.8
            0-13.4-4.3-17.6l-.4-.4c-1.8-1.7-2.5-1.8-4.7-2.9-2.2-1.1-6.8-2.2-9.1-1.7-2.5.5-5.3 2.5-7.3 4.1-.4.3-.8.7-2.2
            1.9 9.6 4.7 17.8 12.5 23.3 22.1z"
                stroke="#000"
                stroke-width="1.5"
                fill="#FFF"
                fill-rule="nonzero"
              />
              <path
                d="M192.6 82.4c-.3-.2-.6-.5-.9-.7-4.1-3.1-9.3-5.2-14.4-3.6L197 72c6.8-2.1 12.9 2 16.3 7.7 2.7 4.5 3.5 8.7
            2.2 16.2l-21.9 9.4c.6-.3 1.4-1.6 1.8-2.2.5-.7 1-1.5 1.4-2.2.7-1.4 1.2-2.9
            1.4-4.4.4-3.3-.3-6.6-1.9-9.5-1.1-1.9-2.3-3.4-3.7-4.6z"
                stroke="#000"
                stroke-width="1.5"
                fill="#034694"
                fill-rule="nonzero"
              />
              <path
                stroke="#000"
                stroke-width="1.5"
                fill="#034694"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M183.4 171.5l16.6-6.3 4.6 18.7-17.2 9.1z"
              />
              <path
                d="M183.4 171.5c-5.9 6.2-15.7 8.8-15.7 8.8l7.3 12.2 12.4.5-4-21.5z"
                stroke="#000"
                stroke-width="1.5"
                fill="#FFF"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M139.5 79.7l-5.1.7-7.4-1.7c-1.4-.5-3.2-.4-4.6-.6-2.4-.3-4.7-.8-7.2-.7 1.6-1.7 3.8-2.2
            5.9-3.2l2.3-1.1c5.5-2 15.5-4.2 20-1.3 1.6 1 3.1 2.2 4.5 3.4 1.3 1.1 2.7 2.4 3.8 3.7-4.2-.2-8.1.3-12.2.8z"
                stroke="#000"
                stroke-width="1.5"
                fill="#034694"
                fill-rule="nonzero"
              />
              <path
                d="M134.8 80.6c-2-2.2-4.4-3.9-7.1-5.1-4.1-2-8.9-1.4-12.4 1.5-2.6 2.1-4.2 5.2-4.5 8.5-.3 3.1.5 5.6 1.4
            8.4l.6 1.9c0 .1 5.4-8.7 22-15.2z"
                stroke="#000"
                stroke-width="1.5"
                fill="#FFF"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M181.4 47.1c-.5-1.3-1.6-2.4-2.9-3-2.1-1-4.6-1.4-6.9-1.4-3.3-.1-6.5.7-9.6 1.6-2.4.7-4.9 1.3-7.3
            1.8-2.3.4-4.1 1.8-6 3-3.1 1.9-6.3 3.9-8.7 6.6-.5.6-1.1 1.1-1.8
            1.5-1.6.6-4.1-.2-5.8-.3-2-.2-4-.6-6-1.1-3.2-.8-7.4-1.8-10.7-1.2-1.2.2-2.3.5-3.4.7-6.2 1.1-13.5 2.2-18.3
            6.4-1.4 1.1-2.1 2.7-2.1 4.4.3 1.7 1.1 3.4 2.1 4.8 1.1 1.4 1.7 2.3 3.8 3.3 5.5 2.6 12.8 2.6 18.8 2.6 5.2 0
            10.3-.7 15.3-1.9 5.1-1.2 9.3-3 14-5.1 7.1-3.1 14.6-4.7 21.8-7.7 1.2-.5 2.3-1 3.3-1.9 1.5-1.3 2.5-3.4 4.2-4.5
            1.8-1.2 3.4-2.4 5.1-3.9l.6-.6c.2-.4.3-.9.5-1.3.3-1.1.3-2 0-2.8z"
                fill="#FFF"
                fill-rule="nonzero"
              />
              <path
                d="M158.8
            65.5c-2.1-2.2-5.3-3.5-8.3-4.6l-3-1.2c-1.7-.7-3.6-1.2-5.5-1.5-3.5-.6-6.9-1.3-10.4-1.8-5.4-.9-10.8-2.1-16.4-1.9-6.3.2-19.9
            2.8-22.7 9-4.1 9.4 11.7 13.1 17.8 13.4 12.7.6 26.9-2.9 38.6-7.6l6-2.4c2.3-.9 4.6-1.9 6.8-2.7 2-.7 3.9-1.9
            5.9-2.5.4-.1.9-.2 1.3-.4.5-.3.9-.6 1.3-1 2.9-2.8 6.1-5 9.1-7.5 2.6-2.1
            3.2-5.3.3-7.6-4.6-3.7-11-3-16.6-1.7-5.3 1.3-10.3 3.4-14.7 6.4-3.7 2.5-8 4.2-11 7.6"
                stroke="#000"
                stroke-width="1.5"
              />
              <path
                stroke="#000"
                stroke-width="1.5"
                fill="#034694"
                fill-rule="nonzero"
                d="M145.7 59.6l21.5-3.9 20.8
            1.5-21.5 3.8zm13 8.4l21.5-3.9-.1 9-21.5 3.9z"
              />
              <path
                stroke="#000"
                stroke-width="1.5"
                fill="#FFF"
                fill-rule="nonzero"
                d="M153.4 67.6l5.3.4-.1
            9-5.3-.4z"
              />
              <path
                d="M188.6 64.6l-21.5 3.9c1.6-.4 2.7-1.8 2.6-3.5.1-2-1.3-3.7-3.3-4l21.5-3.9c2 .3 3.4 2 3.3 4 .1 1.7-1
            3.1-2.6 3.5z"
                stroke="#000"
                stroke-width="1.5"
                fill="#034694"
                fill-rule="nonzero"
              />
              <path
                d="M145 59.6c-1.6.4-2.7 1.8-2.6 3.5-.1 2 1.3 3.7 3.3 4l21.5 1.4c1.6-.4 2.7-1.8
            2.6-3.5.1-2-1.3-3.7-3.3-4L145 59.6z"
                stroke="#000"
                stroke-width="1.5"
                fill="#FFF"
                fill-rule="nonzero"
              />
              <g
                transform="translate(91.000000, 42.000000) translate(18.000000, 40.000000)"
                fill="#000"
                fill-rule="nonzero"
              >
                <path
                  d="M44.4 81c.8.1 1.5.8 1.4 1.7l.1 8.7c.1.7-.5 1.4-1.2
                1.4h-.2c-.8-.1-1.5-.8-1.4-1.7l-.1-8.7c-.1-.7.5-1.4 1.2-1.4h.2zm0-80.6c.8.1 1.5.8 1.4 1.7l.1 8.7c.1.7-.5
                1.4-1.2 1.4h-.2c-.8-.1-1.5-.8-1.4-1.7L43 1.8c-.1-.7.5-1.4 1.2-1.4h.2zm-24 68c.5.1.9.3 1.2.8.4.6.3 1.3-.1
                1.9l-5.7 5.7c-.2.2-.5.3-.8.2-.8-.1-1.4-.9-1.4-1.7 0-.4.1-.7.4-1l5.7-5.7c.1-.2.4-.3.7-.2zm-10-26.8c.8.1
                1.5.8 1.4 1.7.1.7-.5 1.4-1.2 1.4h-.2l-8-.7c-.8-.1-1.5-.8-1.4-1.7-.1-.7.5-1.4 1.2-1.4h.2l8
                .7zm3.9-31.7c.3 0 .6.2.8.4l5.8 6.7c.6.6.6 1.6 0 2.2-.3.3-.6.4-1
                .4s-.8-.2-1-.5l-5.8-6.7c-.5-.7-.4-1.6.3-2.2.3-.2.6-.3.9-.3zm53.9 62.4c.4 0 .7.2 1 .5l5.8 6.7c.5.7.4
                1.6-.3 2.2-.2.2-.5.3-.8.2-.4 0-.8-.2-1-.5l-5.8-6.7c-.5-.7-.3-1.6.4-2.1.1-.3.4-.3.7-.3z"
                />
                <circle cx="43.9" cy="48.1" r="5.7" />
                <path
                  d="M42.3 17.7l4.1.3-.3 26-4.1-.3zm29.2 27.2l-.2 4.1-26.1-.3.3-4.1zm14.7.4c.8.1 1.5.7 1.6 1.6.1.7-.4
                1.4-1.1 1.5h-8.2c-.8-.1-1.5-.7-1.6-1.6-.1-.7.4-1.4 1.1-1.5h8.2zM74.3 16.4c0 .3-.1.6-.3.8l-6.2
                6.3c-.6.6-1.5.7-2.2.2-.3-.2-.4-.6-.4-.9 0-.4.2-.8.5-1l6.2-6.3c.6-.5 1.6-.5 2.2.1.1.2.2.5.2.8z"
                />
              </g>
              <g fill-rule="nonzero">
                <path
                  d="M105.9 172.6c.1 1.8.1 3.7-1.7 4.7-2 1.1-4.4-.1-5.6-1.8-1.4-2-1.9-4.6-2-7-.1-1.7-.3-3.4-.3-5.2 0 .3
                1.1 1 1.3 1.2.6.5 1.2.9 1.9 1.2 1 .5 2.2.8 3.3.8.3 0 .6 0 .9-.1.2-.1.4-.2.7-.4l1.2-.9.1-.1c.4-.1 0 1.2 0
                1.4-.2.5-.3 1-.3 1.6.1 1.6.4 3.1.5 4.6z"
                  fill="#000"
                />
                <path
                  d="M101.8 166.9c3.2.1 5.9-2.7 6.4-6.4l1.6-13.2c.3-4.1-2.3-7.7-5.9-8-3.2-.3-6.1 2.2-6.7 5.9l-1.6
                13.2c-.5 4.1 2 7.9 5.4 8.4.3.1.6.1.8.1h0z"
                  stroke="#000"
                  stroke-width="1.5"
                  fill="#FFF"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M113.5 135.4c.3 2.6.2 5.2-.3 7.8-.9 4.6-1.6 9.2-3 13.6-1.8 5.6-11.3 6.5-15.1
                1.9-4.3-5.5-7.1-12.4-7.8-19.8-.4-6.5 1.6-12.9 5.5-17.5 2.1-2.4 2.9-7 6.2-8.3 4.4-1.8 8.3 5.3 10.1
                8.4.5.9.9 1.8 1.3 2.8 1.6 3.4 2.7 7.2 3.1 11.1z"
                  stroke="#000"
                  stroke-width="1.5"
                  fill="#929294"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M109.3 134.6l-4.6 3.9c-1 .9-2.1 1.7-3.4 2.1-3 1-6-1.4-8.5-3.5"
                  stroke="#000"
                  stroke-width="1.5"
                  fill="#929294"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </svg>
        </div>
        <div class="leo-flex leo-flex-col leo-gap-md leo-pt-xl">
          <div class="leo-text-md leo-text-accent leo-text-center">
            {{ refreshProps.subheading }}
          </div>
          <leo-button primary block class="leo-md" @click="redirectToLogin"
            >Ok</leo-button
          >
        </div>
      </div>
    </leo-dialog>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { CommonClass } from "@/mixins";
import sessionStorageUtils from "@/utils/session-storage";
import debounce from "lodash/debounce";
import { VueLeoDialog } from "@greateasternlife/leo-dialog";
import { VueLeoButton } from "@greateasternlife/leo-button";

export default {
  name: "RefreshPage",
  components: {
    "leo-dialog": VueLeoDialog,
    "leo-button": VueLeoButton,
  },
  data() {
    return {
      events: [
        "click",
        "mousemove",
        "mousedown",
        "mouseover",
        "touch",
        "touchmove",
        "scroll",
        "keyup",
        "load",
      ],
      isShow: false,
      refreshProps: this.$getConstant.refreshPageProp,
      popUpTimer: null,
      logoutTimer: null,
      urlPrefix: this.$getConstant.urlContants,
    };
  },

  mounted() {
    this.events.forEach(function (event) {
      window.addEventListener(event, debounce(this.resetTimer, 400));
    }, this);
    this.setTimers();
  },

  beforeUnmount() {
    window.removeEventListener(event);
  },

  methods: {
    ...mapActions({
      apiLogout: "profile/logoutFlow",
      deleteSessionData: "user/deleteData",
    }),

    setTimers() {
      this.popUpTimer = setTimeout(
        this.showPopup,
        this.$getConstant.refreshPageProp.popupTimer
      ); // 15 min  150 * 1000
    },

    showPopup() {
      this.isShow = true;
      const contentCategoryName = sessionStorage.getItem("content-category-name");
      const channelId = CommonClass.methods.$__checkChannelId();
      const userGroup = CommonClass.methods.$__checkIsDesktopChannel(channelId) ? 'MO' : 'FO';
      const name = this.$route?.path?.split("/")?.pop() || "";
      const virtualPath = `/vpath/${contentCategoryName}/${name} session-timeout`;
      const isRegisterflow = window.location.pathname.includes("register");
      const journeyType = isRegisterflow ? "EB registration personal id" : userGroup + " EB login";
      const appId = isRegisterflow ? "FO EB registration" : userGroup + " EB login";

      window.dataLayer.push({
        event: "virtualPageview",
        virtualPath,
        journeyType,
        appId,
      });
    },

    async redirectToLogin() {
      if (this.$route.path == `${this.urlPrefix.loginUrl}/view-profile`) {
        const payload = {
          flowName: "Logout",
          stepName: "LOGOUT",
          requestID: sessionStorageUtils.getItem("requestID"),
          requestParam: {
            memberId: this.getEmailAddress,
          },
        };
        const resp = await this.apiLogout(payload);
        if (resp?.successFlag) {
          sessionStorageUtils.deleteItem("requestID");
          sessionStorageUtils.deleteItem("loggedIn");
          this.$router.push(`${this.urlPrefix.loginUrl}`);
        }
      } else {
        sessionStorageUtils.deleteItem("requestID");
        sessionStorageUtils.deleteItem("loggedIn");
        console.log("current route", this.$route.name);
        if (this.$route.name === "Login") {
          this.$router.go();
        } else {
          this.$router.push(`${this.urlPrefix.loginUrl}`);
        }
        // location.reload();
        this.isShow = false;
      }
      this.deleteSessionData();
    },

    resetTimer() {
      clearTimeout(this.popUpTimer);
      this.setTimers();
    },
  },

  computed: {
    ...mapGetters({
      getViewProfile: "profile/getData",
      getData: "user/getData",
    }),
    getEmailAddress() {
      return this.getViewProfile?.responseParam?.memberId ?? "";
    },
  },
};
</script>
